import { BsdsButton, BsdsIcon } from '@bsds-lib-component/react';
import type { ReactNode } from 'react';

import type { ButtonProps } from '../../types';

/** Can't send empty text to the default slot of BsdsButton (ex.: only NBSP), which in hover can appear as "-". */
function slotLabelContent(children: ReactNode): ReactNode {
  if (children == null || children === false) return null;
  if (typeof children === 'string') {
    if (children.replace(/[\s\u00A0\u200B\uFEFF]/g, '') === '') return null;
  }
  return children;
}

function Button({
  children,
  icon,
  iconPosition,
  color = "primary",
  disabled = false,
  loading = false,
  fill = "solid",
  onClick,
  type = 'button',
  className,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
  'aria-pressed': ariaPressed,
  'aria-expanded': ariaExpanded,
  'aria-controls': ariaControls,
  'aria-haspopup': ariaHasPopup,
  'aria-disabled': ariaDisabled,
  'aria-busy': ariaBusy,
}: ButtonProps) {
  const iconMarginClass = iconPosition === 'start' ? 'bsds-mr-8' : iconPosition === 'end' ? 'bsds-ml-8' : '';

  return (
    <BsdsButton
      type={type}
      color={color}
      fill={fill}
      loading={loading}
      rippleEffect
      onClick={onClick}
      disabled={disabled || loading}
      className={className}
      platform="web"
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-pressed={ariaPressed}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      aria-haspopup={ariaHasPopup}
      aria-disabled={ariaDisabled}
      aria-busy={ariaBusy}
    >
      {icon && iconPosition && (
        <BsdsIcon icon={icon} slot={iconPosition} className={iconMarginClass} />
      )}
      {slotLabelContent(children)}
    </BsdsButton>
  );
}

export default Button;

